export type EmailDeliverabilityStatus =
  | "idle"
  | "checking"
  | "valid"
  | "invalid"
  | "unknown";

export function shouldBlockOnInvalid(
  ...statuses: EmailDeliverabilityStatus[]
): boolean {
  return statuses.some((status) => status === "invalid");
}
